import React, { useEffect } from 'react';

const ProductPhotoTemplateWidget = ({ selectedLayout,isTemplateId,widgetId,numberCounterTabData }) => {
     const {
        is_website_frontend,
     } = numberCounterTabData || {};

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/photo-gallery/temp-css/PhotoGallery.css`;
        if (widgetId) {
            link.setAttribute("photo-gallery-data-dynamic-css", "photo-gallery");
        } else {
          link.setAttribute("data-dynamic-css", "photo-gallery");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="photo-gallery"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    return (
        <>
            <div className={`upgadeify photo_gallery product-photo-temp ${is_website_frontend}`}>
            <div className='wedding-photog-temp_inner'>
                    <div className='wedding-photog-temp__content'>
                        <div className='wedding-photog-temp_gallery'>
                           <div className='wedding-photog'>
                              <img className='main-imagenew' src="photo-gallery/templates/product-photograher/image.png" alt="imagenew" />
                           </div>
                            <div className='wedding_photog_content'>
                            <div className='wedding_content'>
                                    <h3>Kelly Anderson</h3>
                                    <p className='image-description'>New York</p>
                               </div>
                            </div>
                        </div>
                        <div className='wedding-photog-temp_gallery'>
                           <div className='wedding-photog'>
                                <img className='main-imagenew' src="photo-gallery/templates/product-photograher/image-1.png" alt="image-1" />
                           </div>
                            <div className='wedding_photog_content'>
                               <div className='wedding_content'>
                                    <h3>Kelly Anderson</h3>
                                    <p className='image-description'>New York</p>
                               </div>
                            </div>
                        </div>
                        <div className='wedding-photog-temp_gallery'>
                           <div className='wedding-photog'>
                                <img className='main-imagenew' src="photo-gallery/templates/product-photograher/image-2.png" alt="image-2" />
                           </div>
                            <div className='wedding_photog_content'>
                               <div className='wedding_content'>
                                    <h3>Kelly Anderson</h3>
                                    <p className='image-description'>New York</p>
                               </div>
                            </div>
                        </div>
                        <div className='wedding-photog-temp_gallery'>
                           <div className='wedding-photog'>
                                <img className='main-imagenew' src="photo-gallery/templates/product-photograher/image-3.png" alt="image-3" />
                           </div>
                            <div className='wedding_photog_content'>
                               <div className='wedding_content'>
                                    <h3>Kelly Anderson</h3>
                                    <p className='image-description'>New York</p>
                               </div>
                            </div>
                        </div>
                        <div className='wedding-photog-temp_gallery'>
                           <div className='wedding-photog'>
                                <img className='main-imagenew' src="photo-gallery/templates/product-photograher/image-4.png" alt="image-4" />
                           </div>
                            <div className='wedding_photog_content'>
                               <div className='wedding_content'>
                                    <h3>Kelly Anderson</h3>
                                    <p className='image-description'>New York</p>
                               </div>
                            </div>
                        </div>
                        <div className='wedding-photog-temp_gallery'>
                           <div className='wedding-photog'>
                                <img className='main-imagenew' src="photo-gallery/templates/product-photograher/image-5.png" alt="image-5" />
                           </div>
                            <div className='wedding_photog_content'>
                               <div className='wedding_content'>
                                    <h3>Kelly Anderson</h3>
                                    <p className='image-description'>New York</p>
                               </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ProductPhotoTemplateWidget;
